import { render, staticRenderFns } from "./CustomRequestInfluencerAvatar.vue?vue&type=template&id=73648504"
import script from "./CustomRequestInfluencerAvatar.vue?vue&type=script&lang=js"
export * from "./CustomRequestInfluencerAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports